import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Form } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import Loader from '../../../common/Loader';
import TextInput from '../../../common/forms/input/TextInput';
import FormFooter from '../../../common/forms/FormFooter';
import DynamicForm from '../../../common/forms/DynamicForm';
import { generateInternalTransferItemColumns } from '../../../../config/dynamicFormFields';

const validateFields = (values) => {
  const errors = {};

  if (!values.internalCargoItems || !values.internalCargoItems.length) {
    errors.internalCargoItemsError = 'Debe ingresar un item';
  }

  return errors;
};

export const EditInternalCargoItemForm = ({
  handleSubmit,
  loading,
  onCancel,
}) => {
  const renderDynamicForm = () => (
    <DynamicForm
      name="internalCargoItems"
      columns={generateInternalTransferItemColumns(null, null, null, true)}
      showRemoveButton={false}
      showAddButton={false}
    />
  );

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Field
          name="internalCargoItemsError"
          component={TextInput}
          type="hidden"
        />
        {renderDynamicForm()}
        <FormFooter
          saveButtonColor="info"
          saveButtonText="Modificar"
          saveButtonDisabled={loading}
          saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-pencil'}
        >
          <Button color="primary" onClick={onCancel}>
            Cancelar
          </Button>
        </FormFooter>
      </Form>
    </>
  );
};

EditInternalCargoItemForm.propTypes = {
  loading: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

EditInternalCargoItemForm.defaultProps = {
  loading: false,
};

const mapStateToProps = (state) => ({
  loading: !state.CargoUnit.InternalTransfer.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'EditInternalCargoItemForm',
  validate: validateFields,
})(EditInternalCargoItemForm);

export default connect(mapStateToProps, null)(formComponent);
